import React from "react";
import PanelHead from "../Panel/PanelHead";
import PanelBody from "../Panel/PanelBody";
import TableSupport from "./TableSupport";

const PanelSupport = () => {
  return (
    <div>
      <PanelHead title="Support" />
      <PanelBody content={<TableSupport />} />
    </div>
  );
};

export default PanelSupport;
